export default {"src":"/_next/static/media/img_my_menu_biz.5412dc6b.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};